/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'contract': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M125 118.75v-87.5a6.248 6.248 0 0 0-6.25-6.25h-87.5C27.832 25 25 27.773 25 31.188v87.561c0 3.419 2.832 6.25 6.25 6.25h87.5c3.418 0 6.25-2.831 6.25-6.25v.001zM93.75 62.5l12.5 12.5H75V43.75l12.5 12.5 12.5-12.5 6.25 6.25-12.5 12.5zM75 75v31.25l-12.5-12.5-12.5 12.5-6.25-6.25 12.5-12.5L43.75 75H75z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
